import _slicedToArray from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { MAX_STRING_LENGTH_BYTES, PostConditionPrincipalID, StacksMessageType } from './constants';
import { c32addressDecode } from 'c32check';
import { exceedsMaxLengthBytes } from './utils';
export function parseAssetInfoString(id) {
  var _id$split = id.split(/\.|::/),
      _id$split2 = _slicedToArray(_id$split, 3),
      assetAddress = _id$split2[0],
      assetContractName = _id$split2[1],
      assetTokenName = _id$split2[2];

  var assetInfo = createAssetInfo(assetAddress, assetContractName, assetTokenName);
  return assetInfo;
}
export function createLPString(content, lengthPrefixBytes, maxLengthBytes) {
  var prefixLength = lengthPrefixBytes || 1;
  var maxLength = maxLengthBytes || MAX_STRING_LENGTH_BYTES;

  if (exceedsMaxLengthBytes(content, maxLength)) {
    throw new Error("String length exceeds maximum bytes ".concat(maxLength));
  }

  return {
    type: StacksMessageType.LengthPrefixedString,
    content: content,
    lengthPrefixBytes: prefixLength,
    maxLengthBytes: maxLength
  };
}
export function createAssetInfo(addressString, contractName, assetName) {
  return {
    type: StacksMessageType.AssetInfo,
    address: createAddress(addressString),
    contractName: createLPString(contractName),
    assetName: createLPString(assetName)
  };
}
export function createAddress(c32AddressString) {
  var addressData = c32addressDecode(c32AddressString);
  return {
    type: StacksMessageType.Address,
    version: addressData[0],
    hash160: addressData[1]
  };
}
export function parsePrincipalString(principalString) {
  if (principalString.includes('.')) {
    var _principalString$spli = principalString.split('.'),
        _principalString$spli2 = _slicedToArray(_principalString$spli, 2),
        address = _principalString$spli2[0],
        contractName = _principalString$spli2[1];

    return createContractPrincipal(address, contractName);
  } else {
    return createStandardPrincipal(principalString);
  }
}
export function createContractPrincipal(addressString, contractName) {
  var addr = createAddress(addressString);
  var name = createLPString(contractName);
  return {
    type: StacksMessageType.Principal,
    prefix: PostConditionPrincipalID.Contract,
    address: addr,
    contractName: name
  };
}
export function createStandardPrincipal(addressString) {
  var addr = createAddress(addressString);
  return {
    type: StacksMessageType.Principal,
    prefix: PostConditionPrincipalID.Standard,
    address: addr
  };
}